import { useState } from "react";
import { Button } from "@/components/ui/button";

export type Language = "sv" | "en";

interface LanguageSwitcherProps {
  currentLanguage: Language;
  onLanguageChange: (language: Language) => void;
}

const LanguageSwitcher = ({ currentLanguage, onLanguageChange }: LanguageSwitcherProps) => {
  return (
    <div className="flex rounded-lg border border-border bg-muted/50 p-0.5">
      <Button
        variant={currentLanguage === "sv" ? "default" : "ghost"}
        size="sm"
        onClick={() => onLanguageChange("sv")}
        className="h-6 px-2 text-xs font-medium"
        aria-label="Byt till svenska"
      >
        SV
      </Button>
      <Button
        variant={currentLanguage === "en" ? "default" : "ghost"}
        size="sm"
        onClick={() => onLanguageChange("en")}
        className="h-6 px-2 text-xs font-medium"
        aria-label="Switch to English"
      >
        EN
      </Button>
    </div>
  );
};

export default LanguageSwitcher;